module.exports = __webpack_public_path__ + "static/media/icons-ic-follow-up-demo-transferred.e68c01cc.svg";